import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function LovpakkePriser() {
  const [packages, setPackages] = useState([])
  const [activeTab, setActiveTab] = useState('alle')

  useEffect(() => {
    document.title = 'Lov pakker og priser | Køreskole i Kalundborg | Tilmeld dig i dag'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Se lovpakker og priser hos Borgs Køreskole i Kalundborg. Tilbud på 1. gangs erhvervelse, generhvervelse, trailerkørekort B/E og kørselsforbud.'
      )
    }

    // Fetch pricing from CMS
    async function fetchPricing() {
      try {
        const res = await fetch('https://api.dev.auxo.dk/public/v2/content/priser')
        if (res.ok) {
          const data = await res.json()
          if (data && data.items && data.items.length > 0) {
            setPackages(data.items)
          }
        }
      } catch (err) {
        console.warn('Could not fetch pricing from CMS', err)
      }
    }

    fetchPricing()
  }, [])

  // Detailed scraped data for complete accuracy and fidelity
  const detailedPackages = [
    {
      id: 'første-gangs-erhvervelse',
      title: '1. gangs erhvervelse',
      subtitle: 'Tilbud til 1. gangs erhvervelse af kørekort til alm. bil',
      price: '16.960 kr.',
      signupUrl: 'https://gondrive.com/api/site/school/96/iframe/3?license=B',
      popular: true,
      features: [
        'Teori kursus',
        '17 lovpligtige lektioner på vej*',
        'Manøvrebane',
        'Køreteknisk anlæg'
      ],
      footnotes: [
        '*Bemærk at de lovpligtige lektioner ikke nødvendigvis er nok for at kunne bestå en køreprøve.',
        'Alle priser er inkl. moms.'
      ],
      notIncludedTitle: 'Følgende er Ikke indeholdt i lovpakken men nødvendigt for at kunne få kørekort:',
      notIncluded: [
        'Lægeerklæring (typisk 300-500 kr. skal betales til egen læge)',
        'Førstehjælps bevis 800 kr.',
        'Prøvegebyr 1.600 kr.',
        'Kørekortfoto: 100 kr.',
        'Manøvrebane gebyr',
        'Afholdelse af køreprøve 565 kr.'
      ]
    },
    {
      id: 'genervervelse',
      title: 'Genervervelse',
      subtitle: 'Pakke: orienterende køreprøve og generhvervelse',
      contentHeading: 'Pakke indhold',
      description: 'Tilbud til dig der har fået 3 klip eller har fået en betinget frakendelse og har haft kørekort i mere end 3 år',
      price: '2.500 kr.',
      signupUrl: '/kontakt',
      popular: false,
      features: [
        'Teorikursus på pc med hjemme adgang *',
        '2 køre lektioner på vej*',
        'Afholdelse af køreprøve'
      ],
      footnotes: [
        '*Bemærk at de praktiske lektioner ikke nødvendigvis er nok for at kunne bestå en køreprøve.',
        'Alle priser er inkl. moms',
        'Der er ikke nogen egentlig lovpakke til orienterende køreprøve / generhvervelse, men dette er et godt eksempel på hvad der kræves for at bestå en køreprøve/teoriprøve for bilister med kørsels erfaring.'
      ],
      notIncludedTitle: 'Følgende er Ikke indeholdt i pakken men nødvendigt for at kunne generhverve kørekort:',
      notIncluded: [
        'A/T kursus (om nødvendigt) 3200 kr.',
        'Kørekortfoto: 100 kr.',
        'Prøvegebyr 1.690 kr.'
      ]
    },
    {
      id: 'trailer-koerekort',
      title: 'Trailer kørekort',
      subtitle: 'Tilbud på trailerkørekort',
      price: '5.790 kr.',
      signupUrl: 'https://gondrive.com/api/site/school/96/iframe/3?license=B/E',
      popular: false,
      customContact: {
        text: 'Spørgsmål? Ring til Kurt 40 50 71 54',
        phone: '40507154',
        label: 'Kurt 40 50 71 54'
      },
      features: [
        'Teori kursus 4 lektioner',
        '6 lovpligtige lektioner på vej'
      ],
      footnotes: [
        'Alle priser er inkl. moms.'
      ],
      notIncludedTitle: 'Følgende er Ikke indeholdt i lovpakken men nødvendigt for at kunne få kørekort:',
      notIncluded: [
        'Læge erklæring (typisk 300-500 kr. skal betales til egen læge)',
        'Prøvegebyr: 520 kr.',
        'Kørekortfoto: fra 100 kr.'
      ]
    },
    {
      id: 'koerselsforbud',
      title: 'Kørselsforbud',
      subtitle: 'Særlig undervisning ved kørselsforbud',
      description: 'Tilbud til dig der har fået 2 klip inden for de første 3 år eller er blevet standset af politiet og fået et kørsels forbud.',
      price: '5.700 kr.',
      signupUrl: '/kontakt',
      popular: false,
      features: [
        'Teori kursus, 8 lovpligtige lektioner *',
        '8 lovpligtige lektioner på vej*'
      ],
      footnotes: [
        '*Bemærk: at de lovpligtige lektioner ikke nødvendigvis er nok for at kunne bestå en køreprøve.',
        '*Bemærk: Teorikursus er komplet kursus med hjemme adgang til øvrige lektioner og online teoriprøve.',
        'Alle priser er inkl. moms'
      ],
      notIncludedTitle: 'Følgende er Ikke indeholdt i lovpakken men nødvendigt for at kunne få kørekort:',
      notIncluded: [
        'Afholdelse af køreprøve: 565 kr.',
        'Kørekortfoto: 100 kr.',
        'Prøvegebyr: 1.690 kr.'
      ]
    },
    {
      id: 'motorcykel',
      title: 'Motorcykel hold',
      subtitle: 'Motorcykel undervisning',
      price: 'Ej tilgængelig',
      signupUrl: 'https://www.borgskoereskole.dk/tilmeld-dig-hold/motorcykel.aspx',
      popular: false,
      features: [],
      noticeText: 'Vi kan desværre ikke tilbyde motorcykelhold i 2026.',
      footnotes: [],
      notIncludedTitle: '',
      notIncluded: []
    }
  ]

  const filteredPackages = activeTab === 'alle' 
    ? detailedPackages 
    : detailedPackages.filter(p => p.id === activeTab)

  return (
    <div className="bg-slate-50 min-h-screen py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Heading */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h1 className="font-header text-3xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">
            Lov pakker og priser
          </h1>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
            Se alle vores opstartspakker, lovpakker og priser for kørekort i Kalundborg. Vi tilbyder gennemskuelige priser uden skjulte gebyrer.
          </p>

          {/* Quick Filter Navigation Bar */}
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            <button
              onClick={() => setActiveTab('alle')}
              className={`px-4 py-2 rounded-full text-xs sm:text-sm font-bold transition-all ${
                activeTab === 'alle'
                  ? 'bg-emerald-900 text-white shadow-md'
                  : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
              }`}
            >
              Alle pakker
            </button>
            {detailedPackages.map((pkg) => (
              <button
                key={pkg.id}
                onClick={() => setActiveTab(pkg.id)}
                className={`px-4 py-2 rounded-full text-xs sm:text-sm font-bold transition-all ${
                  activeTab === pkg.id
                    ? 'bg-emerald-900 text-white shadow-md'
                    : 'bg-white text-slate-700 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                {pkg.title}
              </button>
            ))}
          </div>
        </div>

        {/* Detailed Package Cards Grid */}
        <div className="space-y-12 mb-20">
          {filteredPackages.map((pkg) => (
            <div
              key={pkg.id}
              className={`bg-white rounded-2xl border-2 transition-all duration-300 shadow-md overflow-hidden ${
                pkg.popular
                  ? 'border-emerald-600 ring-2 ring-emerald-600/20'
                  : 'border-slate-200 hover:border-slate-300'
              }`}
            >
              {/* Card Header Header */}
              <div className="bg-slate-900 text-white p-6 sm:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6 border-b border-slate-800">
                <div>
                  {pkg.popular && (
                    <span className="inline-block bg-[#8cc73d] text-slate-950 text-xs font-bold px-3 py-1 uppercase tracking-wider mb-2 rounded-full">
                      Mest valgte
                    </span>
                  )}
                  <h2 className="font-header text-2xl sm:text-3xl font-bold text-white">
                    {pkg.title}
                  </h2>
                  <p className="text-emerald-300 text-sm sm:text-base mt-1 font-medium">
                    {pkg.subtitle}
                  </p>
                  {pkg.description && (
                    <p className="text-slate-300 text-sm mt-2 max-w-2xl">
                      {pkg.description}
                    </p>
                  )}
                </div>

                {pkg.price && pkg.price !== 'Ej tilgængelig' && (
                  <div className="text-left md:text-right shrink-0">
                    <div className="text-3xl sm:text-4xl font-black text-[#8cc73d] font-header">
                      Betal kun {pkg.price}
                    </div>
                    <span className="text-xs text-slate-400 block mt-1">Alle priser er inkl. moms</span>
                  </div>
                )}
              </div>

              {/* Card Body */}
              <div className="p-6 sm:p-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
                
                {/* Left Column: Lovpakke indhold */}
                <div>
                  <h3 className="font-header text-lg font-bold text-slate-900 mb-4 flex items-center gap-2">
                    <i className="fa-solid fa-box-archive text-emerald-600" aria-hidden="true"></i>
                    <span>{pkg.contentHeading || 'Lovpakke indhold'}</span>
                  </h3>

                  {pkg.noticeText ? (
                    <div className="p-4 bg-amber-50 border border-amber-200 text-amber-900 rounded-lg font-semibold text-sm">
                      {pkg.noticeText}
                    </div>
                  ) : (
                    <ul className="space-y-2.5 mb-6">
                      {pkg.features.map((feat, idx) => (
                        <li key={idx} className="flex items-start gap-3 text-slate-800 text-sm sm:text-base">
                          <i className="fa-solid fa-circle-check text-emerald-600 text-lg mt-0.5" aria-hidden="true"></i>
                          <span className="font-medium">{feat}</span>
                        </li>
                      ))}
                    </ul>
                  )}

                  {/* Footnotes */}
                  {pkg.footnotes && pkg.footnotes.length > 0 && (
                    <div className="mt-6 pt-4 border-t border-slate-100 text-xs text-slate-500 space-y-1.5 leading-relaxed">
                      {pkg.footnotes.map((fn, idx) => (
                        <p key={idx}>{fn}</p>
                      ))}
                    </div>
                  )}
                </div>

                {/* Right Column: Nødvendige ekstraudgifter udover lovpakken */}
                {pkg.notIncluded && pkg.notIncluded.length > 0 && (
                  <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                    <h3 className="font-header text-base sm:text-lg font-bold text-slate-900 mb-3 flex items-start gap-2">
                      <i className="fa-solid fa-[#8cc73d] fa-circle-info text-amber-600 mt-1 shrink-0" aria-hidden="true"></i>
                      <span>{pkg.notIncludedTitle}</span>
                    </h3>

                    <ul className="space-y-2 text-xs sm:text-sm text-slate-700">
                      {pkg.notIncluded.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <span className="text-slate-400 font-bold">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Card Footer Actions */}
              <div className="bg-slate-50 px-6 sm:px-8 py-4 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-xs text-slate-600 flex items-center gap-2">
                  <i className="fa-solid fa-phone text-emerald-600" aria-hidden="true"></i>
                  {pkg.customContact ? (
                    <span>Spørgsmål? Ring til <a href={`tel:${pkg.customContact.phone}`} className="font-bold underline text-slate-900 hover:text-emerald-700">{pkg.customContact.label}</a></span>
                  ) : (
                    <span>Spørgsmål? Ring til Kim eller Mette på <a href="tel:21470187" className="font-bold underline text-slate-900 hover:text-emerald-700">21 47 01 87</a> / <a href="tel:23200425" className="font-bold underline text-slate-900 hover:text-emerald-700">23 20 04 25</a></span>
                  )}
                </div>

                {pkg.signupUrl.startsWith('http') ? (
                  <a
                    href={pkg.signupUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full sm:w-auto px-6 py-3 rounded-full bg-[#8cc73d] hover:bg-[#7eb832] text-slate-950 font-bold text-sm text-center transition-all shadow-sm flex items-center justify-center gap-2"
                  >
                    <span>Tilmeld dig i dag</span>
                    <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true"></i>
                  </a>
                ) : (
                  <Link
                    to={pkg.signupUrl}
                    className="w-full sm:w-auto px-6 py-3 rounded-full bg-[#8cc73d] hover:bg-[#7eb832] text-slate-950 font-bold text-sm text-center transition-all shadow-sm flex items-center justify-center gap-2"
                  >
                    <span>Tilmeld dig / Kontakt os</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Info box: Lidt om os & Finansiering */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
          <div className="bg-emerald-900 text-white p-8 rounded-2xl shadow-md">
            <h3 className="font-header text-xl font-bold mb-3 flex items-center gap-2">
              <i className="fa-solid fa-heart text-[#8cc73d]" aria-hidden="true"></i>
              <span>Lidt om os</span>
            </h3>
            <p className="text-emerald-100 text-sm leading-relaxed">
              Vi går meget op i, at du ikke skal være nervøs under dine kørelektioner, samt at det skal være sjovt og spændende at tage kørekort.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-md">
            <h3 className="font-header text-xl font-bold text-slate-900 mb-3 flex items-center gap-2">
              <i className="fa-solid fa-piggy-bank text-emerald-600" aria-hidden="true"></i>
              <span>Finansiering af kørekort</span>
            </h3>
            <p className="text-slate-600 text-sm leading-relaxed mb-4">
              Har du brug for at dele betalingen af dit kørekort op? Du kan søge om finansiering via vores samarbejdspartner Lendo.
            </p>
            <a
              href="https://www.lendo.dk/partner/borgs-koreskole"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-bold text-emerald-700 hover:text-emerald-900"
            >
              <span>Læs mere om finansiering hos Lendo</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
  )
}
